/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalEntityDisplayResource
 */
export interface LegalEntityDisplayResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDisplayResource
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDisplayResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDisplayResource
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDisplayResource
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the LegalEntityDisplayResource interface.
 */
export function instanceOfLegalEntityDisplayResource(value: object): value is LegalEntityDisplayResource {
    return true;
}

export function LegalEntityDisplayResourceFromJSON(json: any): LegalEntityDisplayResource {
    return LegalEntityDisplayResourceFromJSONTyped(json, false);
}

export function LegalEntityDisplayResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityDisplayResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function LegalEntityDisplayResourceToJSON(value?: LegalEntityDisplayResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'formattedAddress': value['formattedAddress'],
        'countryCode': value['countryCode'],
    };
}

